import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
//Modules
import auth from './modules/auth';
import shared from './modules/shared';
import companies from './modules/companies';
import entities from './modules/entities';
import entitycategories from './modules/entitycategories';
import adresses from './modules/adresses';
import lists from './modules/lists';
import tags from './modules/tags';
import specifications from './modules/specifications';
import recipesteps from './modules/recipesteps';
import units from './modules/units';
import tagcategories from './modules/tagcategories';
import treatments from './modules/treatments';
import preparations from './modules/preparations';
import companycategories from './modules/companycategories';
import logos from './modules/logos';
import projects from './modules/projects';
import search from './modules/search';
import messages from './modules/messages';

Vue.use(Vuex)


const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})


const state = {    
        
    
    authMenuItems:[
        {title:'Login', 
        icon:'lock_open', 
        link:'/login',        
        action:'' ,  
        hassub:false
        },
        {title:'Register', 
        icon:'lock_open', 
        link:'/register',        
        action:'' ,  
        hassub:false
        },    
    ],            
        
    menuItems:[                
        {title:'Neu anlegen', 
        icon:'directions',  
        hassub:true,
        sub:[
                {title:'Rezept/Zutat', icon:'layers', link:'/entities/create'},
                {title:'Firmen', icon:'layers', link:'/companies/create'},
                {title:'Adressen', icon:'layers', link:'/adresses/create'},
                {title:'Projekte', icon:'layers', link:'/projects/create'}
            ],
        action:'',
        link:''

        },  
        {title:'Admin', 
        icon:'group', 
        sub:[
                {title:'Tags', icon:'local_post_office', link:'/tags/create'},                
                {title:'Tagkategorien', icon:'local_post_office', link:'/tagcategories/create'},
                {title:'Spezifikationen', icon:'local_post_office', link:'/specifications/create'},
                {title:'Verarbeitungen', icon:'local_post_office', link:'/treatments/create'},
                {title:'Zubereitungen', icon:'local_post_office', link:'/preparations/create'},
                {title:'Maßeinheiten', icon:'local_post_office', link:'/units/create'},
                

            ], 
        action:'',
        link:''
        },                    
        

    ],  
    
};

export default new Vuex.Store({
    modules: {
        projects: projects,
        auth: auth,
        shared:shared,
        companies:companies,
        entities:entities,
        adresses:adresses,
        lists:lists,
        tags:tags,
        entitycategories:entitycategories,
        specifications:specifications,
        recipesteps:recipesteps,
        treatments:treatments,
        tagcategories:tagcategories,
        units:units,
        preparations:preparations,
        companycategories:companycategories,
        logos:logos,
        search:search,
        messages:messages
        
    },
    //plugins: [vuexLocal.plugin],
    state,
    actions,
    getters,
    mutations
});
